export default __webpack_public_path__ + "static/media/02.77c2f28b.jpg";